import { render } from "./quotationSendForm.vue?vue&type=template&id=386c89f2"
import script from "./quotationSendForm.vue?vue&type=script&lang=js"
export * from "./quotationSendForm.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__